export default {
  pkf: {
    label: 'PKF',
    component: () => import('./pkf/index')
  },
  standroll: {
    label: 'Stand & Roll',
    component: () => import('./standroll/index')
  },
  runner: {
    label: 'Runner',
    component: () => import('./runner/index')
  },
  std_seat: {
    label: 'Standard Seat',
    component: () => import('./std-seat/index')
  },
  custom_seat: {
    label: 'Custom Milled Seat',
    component: () => import('./custom-seat/index')
  },
  abs_thermo: {
    label: 'ABS Thermoforming',
    component: () => import('./abs-thermo/index')
  },
  upholstry: {
    label: 'Upholstry',
    component: () => import('./upholstry/index')
  }
}
